import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import TextInput from '../../../App/Components/Form/TextInput/TextInput'
import { Box } from '../../../Common/Box'
import { IUserHr } from '../../../User/UsersHr/interfaces/IUserHr'

import { PersonEditText } from './style'

type Props = {
  personObject: IUserHr
  setPersonObject: (person: IUserHr) => void
}

export const LastNameEditInput: React.FC<Props> = ({
  personObject,
  setPersonObject,
}) => {
  const { t } = useTranslation()

  return (
    <Box mt={2} mb={2}>
      <PersonEditText>{t('Last name')}</PersonEditText>
      <TextInput
        value={personObject.lastName}
        onChange={e =>
          setPersonObject({ ...personObject, lastName: e.currentTarget.value })
        }
      />
    </Box>
  )
}
